import { DateTimeUtils, Table } from "dyl-components";
import Destinations from "pages/PhoneManagement/Numbers/DylNumbers/subcomponents/Destinations";
import { Icon, Popup } from "semantic-ui-react";
import { MathUtils, PhoneUtil, StringUtils } from "utils";

const Subscription = ({
    price,
    productInfo,
    user,
    RowCheckboxComponent,
    id,
    extension,
    canceled,
    onRestore,
    restored,
    valid_revert_time,
    hasOutstandingInvoices,
    campaign_name,
    phone_number,
    price_schedule,
    discount_expiration_date,
    isDisabled
}) => {
    const ext = extension ? `Ext: ${extension}` : '';
    return (
        <Table.Row>
            {RowCheckboxComponent && (
                <Table.Cell>
                    <RowCheckboxComponent
                        id={id}
                        disabled={isDisabled}
                        onRemove={restored ? () => { onRestore(id) } : null}
                    />
                </Table.Cell>
            )}
            <Table.Cell disabled={hasOutstandingInvoices}>{productInfo}</Table.Cell>
            <Table.Cell disabled={hasOutstandingInvoices}>
                {user && (
                    <Destinations destination={{ label: ext, type: "direct_extension", user_id: user.id, username: user.username, active: user.active }} />
                )}
                {
                    !user && extension && (<>
                        Ext: {extension}
                    </>)
                }
                {
                    campaign_name && (<>
                        {campaign_name}</>)
                }
                {
                    phone_number && (<>
                        {PhoneUtil.formatPhoneNumber(phone_number)}</>)
                }
            </Table.Cell>
            <Table.Cell disabled={hasOutstandingInvoices}>
                ${StringUtils.formatDecimal(`${MathUtils.roundDecimals(price ? price : 0)}`, true)} {
                    RowCheckboxComponent && canceled && !restored && (
                        <Popup
                            inverted
                            trigger={(
                                <Icon
                                    className="fa-sharp fa-solid fa-arrow-rotate-left Pipeline__stage-undo-icon"
                                    size="large"
                                    link
                                    onClick={onRestore}
                                />
                            )}
                            content={`Valid until ${DateTimeUtils.changeFormat(DateTimeUtils.convertUnixTimeToDate(valid_revert_time), "", DateTimeUtils.WORD_DATE_FORMAT)}`}
                        />
                    )
                }
            </Table.Cell>
            <Table.Cell>{price_schedule}</Table.Cell>
            <Table.Cell>
                {discount_expiration_date && DateTimeUtils.changeFormat(
                    DateTimeUtils.convertUnixTimeToDate(
                        discount_expiration_date,
                        "UTC"
                    ),
                    "",
                    DateTimeUtils.DATE_FORMAT,
                    "UTC"
                )}
            </Table.Cell>
        </Table.Row>
    );
};

export default Subscription;
